export default {
    buttons: {
        save: 'Sačuvaj',
    },
    fields: {
        password: {
            label: 'Lozinka',
            placeholder: '6 karaktera minimum',
        },
        password_repeat: {
            label: 'Ponoviti lozinku',
            placeholder: 'Unesite lozinku ponovo',
        },
    },
    passwords_not_match: 'Lozinke se ne podudaraju',
}
